var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClosedMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4857 0.428572H1.51425C0.759965 0.428572 0.149679 1.05536 0.149679 1.82143L0.142822 10.1786C0.142822 10.9446 0.759965 11.5714 1.51425 11.5714H12.4857C13.24 11.5714 13.8571 10.9446 13.8571 10.1786V1.82143C13.8571 1.05536 13.24 0.428572 12.4857 0.428572ZM12.4857 10.1786H1.51425V3.21429L6.99997 6.69643L12.4857 3.21429V10.1786ZM6.99997 5.30357L1.51425 1.82143H12.4857L6.99997 5.30357Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedMail);
export default __webpack_public_path__ + "static/media/closedMail.e055faf7.svg";
export { ForwardRef as ReactComponent };